import React from 'react';
import { Typography } from '@tq/ui-components';
import { tqc } from '@tq/ui-components/dist/system';

import { useIsMobile } from '@tq/ui-components/dist/hooks';

export type PageHeadingProps = {
  heading: string;
  mobileHeading?: string;
};

export const PageHeading: React.FC<PageHeadingProps> = ({ heading, mobileHeading }) => {
  const isMobile = useIsMobile();

  return (
    <Typography>
      <tqc.h1 color='black' marginBottom={0}>
        {isMobile ? mobileHeading ?? heading : heading}
      </tqc.h1>
    </Typography>
  );
};
